import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useBranchList = () => {
  const [loading, setLoading] = useState(true);
  const [branchesList, setBranchesList] = useState({});
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getBranchesList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('Product/Branch/List', { params })
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          setBranchesList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              title: element.title,
              // hasGraph: element.hasGraph,
              codding: element.codding,
              display: element.display,
              isDefault: element.isDefault,
              isReadOnly: element.isReadOnly,
              isTitleRequired: element.isTitleRequired,
              logic: element.logic,
              profileName: element.profileName,
              type: element.type,
              displayOrigin: element.displayOrigin,
              guidOrigin: element.guidOrigin,
              imageKey: element.imageKey,
              imageURL: element.imageURL,
            }));

            return { ...prev, [params?.page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getBranchesList, loading, branchesList, pageRef];
};

export default useBranchList;
